module.exports = __webpack_public_path__ + "src/equalone-ui/components/coupon/coupon.tpl-2849b51b599f99f0ca093c908ad8e851.html";


//////////////////
// WEBPACK FOOTER
// ./src/equalone-ui/components/coupon/coupon.tpl.html
// module id = 63
// module chunks = 0